import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FolderFile } from '@api/index';
import { FolderApi } from '@api/services/folder-api';
import { SystemMessageService } from '@app/core/services/system-message.service';
import { TranslateConfigService } from '@app/core/translate-config.service';

@Component({
  selector: 'flow-move-file-to-folder-modal',
  templateUrl: './move-file-to-folder-modal.component.html',
  styleUrls: ['./move-file-to-folder-modal.component.scss'],
})
export class MoveFileToFolderModalComponent implements OnInit {
  // value used to represent root folder (id: null) in mat-select since mat-select doesn't handle null values well
  private static readonly ROOT_FOLDER_ID = -1;

  folders: FolderFile[];
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
    public dialogRef: MatDialogRef<MoveFileToFolderModalComponent>,
    private formBuilder: FormBuilder,
    private folderApi: FolderApi,
    private systemMessageService: SystemMessageService,
    private translateConfigService: TranslateConfigService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.setFoldersList();
  }

  setFoldersList() {
    const root: FolderFile = {
      id: MoveFileToFolderModalComponent.ROOT_FOLDER_ID,
      name: this.translateConfigService.instant('global.home'),
      size: 0,
      media: null,
      customer: null,
      type: 3,
    };

    this.folders = this.data?.isInFolder ? [root, ...this.data.folders].filter(f => f.id !== this.data.folderId) : [...this.data.folders];
  }

  moveFile() {
    const selectedFolderId: number = this.form.get('folder').value;
    // Map sentinel value back to null for root folder API call
    const folderId: number | null = selectedFolderId === MoveFileToFolderModalComponent.ROOT_FOLDER_ID ? null : selectedFolderId;
    const folder = this.folders?.find(f => f.id === selectedFolderId);

    const mediaIds = this.data.mediaId ? [this.data.mediaId] : this.data.mediaIds;
    const translationKey = this.data.mediaId ? 'notifications.success.fileMoved' : 'notifications.success.filesMoved';

    this.folderApi.moveMediasToFolder(folderId, mediaIds).subscribe({
      next: () => {
        const folderName = folder?.name ?? this.translateConfigService.instant('global.home');
        this.systemMessageService.success(this.translateConfigService.instant(translationKey, folderName));
        this.dialogRef.close(true);
      },
    });
  }

  initForm() {
    this.form = this.formBuilder.group({
      folder: [null, Validators.required],
    });
  }
}

interface ModalData {
  folders: FolderFile[] | null;
  mediaId: number;
  mediaIds: number[];
  folderId: number | null;
  isInFolder: boolean | null;
}
